import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/mainPage.vue'
import store from '@/store/index'
import NotFound from '@/views/notFound'

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/lk',
    name: 'lk',
    beforeEnter: ifAuthenticated,
    component: () => import('@/views/profile-component.vue'),
    children: [
      { name: 'Текущие рассрочки', path: 'installments', component: () => import('@/views/installments-component') },
      { name: 'Профиль', path: 'profile', component: () => import('@/views/profile-info') },
      { name: 'История', path: 'history', component: () => import('@/views/history-component') }
    ],
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login-form.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../components/Parts/compTable.vue')
  },
  {
    path: '/registration',
    name: 'registration',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/registration-form.vue')
  },
  {
    path: '/sms-code-form',
    name: 'sms-code-form',
    component: () => import(/* webpackChunkName: "about" */ '../views/sms-code-form.vue')
  },
  {
    path: '/new-pass-form',
    name: 'new-pass-form',
    component: () => import(/* webpackChunkName: "about" */ '../views/new-pass-form.vue')
  },
  {
    path: '/examples',
    name: 'examples',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/call',
    name: 'call',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
